import { useQuery } from '@tanstack/react-query';
import { getAllRoles, getRolesPaged, RoleDto, RoleListParams, RoleListResult } from '../services/roleService';
import { configurationKeys } from '../queryKeys';

export function useRoles(tenantId: string) {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery<RoleDto[], Error>({
    queryKey: configurationKeys.roles.list(tenantId),
    queryFn: () => getAllRoles(tenantId),
    enabled: Boolean(tenantId),
    staleTime: 30_000,
  });

  return {
    roles: data ?? [],
    isLoading,
    isFetching,
    isError,
    error: error ?? null,
    refetch,
  };
}

/**
 * Server-side paginated/searchable variant, used only by the Roles Configuration
 * screen's table. `useRoles` above is left untouched — it still serves dropdown
 * selects and the permission-matrix role picker unpaginated.
 */
export function useRolesList(params: RoleListParams) {
  const { data, isLoading, isFetching, isError, error, refetch } = useQuery<RoleListResult, Error>({
    queryKey: configurationKeys.roles.paged(params),
    queryFn: () => getRolesPaged(params),
    enabled: Boolean(params.tenantId),
    staleTime: 30_000,
    placeholderData: (previous) => previous,
  });

  return {
    roles: data?.items ?? [],
    totalCount: data?.totalCount ?? 0,
    isLoading,
    isFetching,
    isError,
    error: error ?? null,
    refetch,
  };
}
